import Swiper, {Scrollbar} from 'swiper';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
const breakpoint = window.matchMedia('(min-width: 992px)');
let mySwiper;

const breakpointChecker = function () {
    if (breakpoint.matches === true) {
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
    } else if (breakpoint.matches === false) {
        return enableSwiper();
    }
};

const enableSwiper = function () {
    mySwiper = new Swiper('.people-blocks', {
        modules: [Scrollbar],
        slidesPerView: 'auto',
        scrollbar: {
            el: ".people-scrollbar",
            hide: false,
            draggable: true
        },
    });
};

breakpoint.addListener(breakpointChecker);

breakpointChecker();